/* eslint-disable no-restricted-imports */

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core';
import { Warning as WarningIcon } from '@material-ui/icons';

export function CancelInvoiceDialog({ open, onClose, onConfirm, invoiceNumber, cancelling }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth='sm' fullWidth>
      <DialogTitle>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <WarningIcon color='error' />
          Cancelar Nota Fiscal {invoiceNumber}
        </div>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <strong>ATENÇÃO:</strong> Esta ação irá:
        </DialogContentText>
        <DialogContentText component='div'>
          <ul style={{ marginTop: 8, paddingLeft: 20 }}>
            <li>Marcar a nota fiscal como CANCELADA no sistema</li>
            <li>
              <strong>Reverter o faturamento</strong> - As quantidades faturadas dos itens serão
              decrementadas
            </li>
            <li>Os itens poderão ser faturados novamente em outra nota fiscal</li>
            <li>Registrar o cancelamento no histórico do pedido</li>
          </ul>
        </DialogContentText>
        <DialogContentText style={{ marginTop: 16, fontWeight: 'bold', color: '#d32f2f' }}>
          Certifique-se de que a nota fiscal já foi cancelada no TinyERP antes de prosseguir!
        </DialogContentText>
        <DialogContentText style={{ marginTop: 8 }}>
          Você tem certeza que deseja cancelar esta nota fiscal?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={cancelling}>
          Não, voltar
        </Button>
        <Button onClick={onConfirm} color='secondary' variant='contained' disabled={cancelling}>
          {cancelling ? 'Cancelando...' : 'Sim, cancelar nota fiscal'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
